<template>
  <div class="campus">
    <div v-if="editMode || saving" class="edit-mode">
      <input-type-ahead
        :list="campuses"
        :value="value && value.id"
        :searchchange="getCampusesWithTimeout"
        :selected-value="selectCampus"
        placeholder="Search for a Campus..."
        :label="null"
        option-value="id"
        option-text="name"
      />
      <div class="button-group">
        <b-button
          style="background-color: green;"
          class="action-btn"
          @click="saveCampus"
        >
          <font-awesome-icon
            v-if="saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <font-awesome-icon v-else :icon="['fas', 'check']" />
        </b-button>
        <b-button
          style="background-color: #ff4000;"
          class="action-btn"
          @click="closeEditMode"
        >
          <font-awesome-icon
            :icon="['fas', 'xmark']"
          />
        </b-button>
      </div>
    </div>
    <div
      v-else
      id="hover-area"
      class="hover-area"
      @mouseover="showButton = true"
      @mouseleave="showButton = false"
    >
      <span> {{ value.name }}</span>
      <b-button
        v-if="showButton"
        class="edit-btn"
        @click="editCampus"
      >
        Edit
      </b-button>
    </div>
  </div>
</template>

<script>
  import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
  import StudentClient from '@/api/StudentClient';

  export default {
    name: 'CampusSearchDropDown',
    components: {
      InputTypeAhead,
    },
    props: {
      value: {
        type: Object,
        require: false,
        default: () => null,
      },
      saving: {
        type: Boolean,
        require: true,
        default: false
      },
      record: {
        type: Object,
        require: false,
        default: () => null
      }
    },
    data() {
      return {
        studentClient: new StudentClient(this.$http),
        campusTimeout: null,
        campuses: [],
        campus: null,
        editMode: false,
        showButton: false,
      };
    },
    async mounted() {
      try {
        await this.fetchAndSetCampuses(null, this.emailDomain);
      } catch (ex) {
        console.error(ex);
      }
    },
    methods:{
      closeEditMode() {
        this.editMode = false;
      },
      editCampus() {
        this.editMode = true;
      },
      saveCampus() {
        this.$emit('input', this.selectedCampus, this.record);
        this.editMode = false;
      },
      getCampusesWithTimeout(query) {
        if (this.campusTimeout) {
          clearTimeout(this.campusTimeout);
          this.campusTimeout = null;
        }

        this.campusTimeout = setTimeout(async () => {
          if (!query) return;
          await this.fetchAndSetCampuses(query);
        }, 300);
      },
      async fetchAndSetCampuses(query, domain) {
        const response = await this.studentClient.campusSearch(query, domain);
        this.campus = null;
        this.campuses = response.campuses || [];
      },
      selectCampus(v) {
        this.selectedCampus = this.campuses.find(x => x.id === v);
      },
    }
  }
</script>

<style scoped lang="scss">

.campus {
  min-width: 200px;
    .edit-mode {
      position: relative;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
      .button-group {
        position: absolute;
        display: inline-flex;
        align-items: center;
        top: 50%;
        left: 100%;
        transform: translateY(-50%);
        
        .action-btn {
          margin-left: 5px;
          white-space: nowrap;
          border: 1px solid $border-color;
          box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.4);
        }
    }
  }
  .hover-area {
    display: inline-block;
    position: relative;
    white-space: nowrap;

    .text-container {
      display: inline;
    }

    .edit-btn {
      display: none;
      position: absolute;
      top: 50%;
      left: 100%;
      transform: translate(0%, -50%);
      white-space: nowrap;
      border: 1px solid $border-color;
      margin-left: 5px;
      box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.4);
    }
  }

  .hover-area:hover {
    border: 1px solid $border-color;
    border-radius: 5px;
    padding: 8px;
    box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.4);
    .edit-btn {
      display: inline-block;
    }
  }
}
</style>
